'use client'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useEffect } from 'react'

import AnalyticsPageView from '@/app/AnalyticsPageView'
import ENV_VARS from '@/global/environmentVariables'
import { analytics } from '@/services/analytics'

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    analytics.init()
  }, [])

  // Only wrap with PostHog provider in production
  if (ENV_VARS.VERCEL_ENV !== 'production') {
    return <>{children}</>
  }

  const analyticsInstance = analytics.getAnalyticsInstance()
  if (!analyticsInstance) {
    return <>{children}</>
  }

  return (
    <PHProvider client={analyticsInstance}>
      <AnalyticsPageView />
      {children}
    </PHProvider>
  )
}
